<template>
    <div style="margin: 20px 0 30px">
        <el-table :data="data" size="small" class="ah-el-data-table no-bottom-border row-click" @row-click="$event => $emit('row-click', $event)">
            <el-table-column type="index"></el-table-column>
            <el-table-column label="類型" width="85">發票</el-table-column>
            <el-table-column label="單號" prop="ioo" width="140"></el-table-column>
            <el-table-column label="存簿戶名" prop="fnam">
                <template slot-scope="scope">
                    <span class="">{{ scope.row.fnam }}</span>
                </template>
            </el-table-column>
            <el-table-column label="金額" prop="incomeAmount" align="right">
                <template slot-scope="scope">
                    <Money :v="scope.row.incomeAmount" />
                </template>
            </el-table-column>
            <el-table-column label="幣別" prop="cny" width="80">
                <template slot-scope="scope">
                    <span>{{ scope.row.cny }}</span>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    mixins: [],
    props: {
        data: {
            type: Array,
            default: () => [],
        },
    },
    components: {},
    data() {
        return {};
    },
    computed: {},
    created() {},
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped></style>
